import {Helmet} from 'react-helmet';
import useInvestForm from '../../hooks/useInvestForm';
import Button from '../button/button';
import InputController from '../input/input.controller';
import InvestAmount from '../invest-amount/invest-amount';
import InvestHint from '../invest-hint/invest-hint';
import './casual-invest-form.sass';

interface IProps {
  projectId: string;
  isEmbed?: boolean;
}

const CasualInvestForm: React.FC<IProps> = ({projectId, isEmbed}) => {
  const investForm = useInvestForm(projectId, isEmbed);
  if (!investForm) return null;
  return (
    <div className="casual-invest-form">
      <Helmet>
        <title>{investForm.project?.title}</title>
        <meta name="description" content={investForm.project?.description} />
      </Helmet>
      <form
        className="casual-invest-form__inner"
        onSubmit={e => {
          if (investForm.submitButton.disabled) e.preventDefault();
          else {
            investForm.confirmModal.open(e);
          }
        }}
      >
        <div className="casual-invest-form__label">HOW MUCH WOULD YOU LIKE TO INVEST?</div>
        <InvestAmount
          className={'casual-invest-form__field'}
          label={
            <>
              Enter amount<span>*</span>
            </>
          }
          onClickMax={investForm.setMaxAmount}
          onClickMin={investForm.setMinAmount}
          // value={investForm.watch('amount')}
          error={investForm.errors.amount?.message as string}
          investAmount={investForm.investAmount}
          tokenSelect={investForm.fields.token}
          tokens={investForm.tokens || []}
          {...investForm.fields.amount}
        />
        {investForm.project && (
          <div className="casual-invest-form__hint">
            <InvestHint project={investForm.project} tokenIcon={investForm.investAmount.tokenIcon} />
          </div>
        )}
        <div className="casual-invest-form__body">
          <div className="casual-invest-form__row">
            <InputController
              className={'casual-invest-form__field'}
              label={
                <>
                  Address<span>*</span>
                </>
              }
              error={investForm.errors.address?.message as string}
              {...investForm.fields.address}
            />
          </div>
          <div className="casual-invest-form__row">
            <InputController
              className={'casual-invest-form__field'}
              label={
                <>
                  Email<span>*</span>
                </>
              }
              error={investForm.errors.email?.message as string}
              {...investForm.fields.email}
            />
            <InputController
              className={'casual-invest-form__field'}
              label={
                <>
                  Full name<span>*</span>
                </>
              }
              error={investForm.errors.fullName?.message as string}
              {...investForm.fields.fullName}
            />
          </div>
          <div className="casual-invest-form__row">
            <InputController
              className={'casual-invest-form__field'}
              label={<>Telegram</>}
              error={investForm.errors.telegram?.message as string}
              {...investForm.fields.telegram}
            />
          </div>
          <div className="casual-invest-form__row">
            <InputController
              className={'casual-invest-form__field'}
              label="Tell us your story"
              error={investForm.errors.story?.message as string}
              {...investForm.fields.story}
              multiline
            />
          </div>
        </div>
        <div className={'casual-invest-form__button'}>
          <Button {...investForm.submitButton}>{investForm.submitButton.title}</Button>
        </div>
        {investForm.formState.error && <div className="casual-invest-form__error">{investForm.formState.error}</div>}
      </form>
    </div>
  );
};

export default CasualInvestForm;
